import { createElement } from 'react';

import IconDeepResearchText from '@components/Images/DeepResearch/IconDeepResearchText';
import { deep_research_path, events_path } from '@routes';
import { IMGIX_URL } from '@src/env';

export const OFFERING_HEADLINE = 'Stay Informed, Stay Connected';
export const OFFERINGS = [
  {
    headline: createElement(IconDeepResearchText, { className: 'deep-research-logo-big' }),
    description:
      'Accelerate your research with AI-powered answers grounded in over a decade of The Information’s trusted reporting, org charts and data.',
    link: deep_research_path(),
    buttonText: 'Try Asking',
  },
  {
    headline: 'Subscriber Events',
    description:
      'Join exclusive live conversations with industry leaders to explore the biggest questions in tech and finance.',
    link: events_path(),
    buttonText: 'View events',
  },
  {
    headline: 'Pro Newsletters',
    description:
      'Get curated weekly briefings from our reporters, plus exclusive survey results and Pro-only articles in your inbox.',
    link: '/features/pro-weekly',
    buttonText: 'Discover more',
  },
];

export const PHONE_IMAGE_URL = `${IMGIX_URL}/global/pro/pro_cluster_offerings.gif`;

export const QUOTE = {
  person: 'Rustom',
  personTitle: 'Account Director',
  quote:
    'I wanted to quickly familiarize myself with org charts of specific companies… That led me to a Pro subscription. I cannot imagine following this rapidly evolving sector without a subscription.',
};
